import axios from 'axios';
import { Config } from 'config';

export interface ITenderAndCheckoutRequest {
    amountPaidViaCreditCard: number;
    approvalCode: string;
    cardNumber: string;
    creditCardTypeName: string;
    expirationDate?: Date;
    token: string;
}

export const TenderAndCheckout = (
    id: number,
    request: ITenderAndCheckoutRequest,
    onSuccess: () => void,
    onFailure: (reason: object) => void
) => {
    const url = `${Config.url.PAYMENT_URL}/Checkout/${id}`;

    axios.post(url, request).then(
        () => onSuccess(),
        (reason) => onFailure(reason)
    );
};
